import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Card from '@material-ui/core/Card';
import Icon from '@material-ui/core/Icon';
import Button from '../../../atomic/Buttons/Button';
import {
  sortableElement,
} from 'react-sortable-hoc';

//Components
import DragHandle from './DragHandle';

const CardStyled = styled(Card)`
  display: flex;
  justify-content: space-between;
  min-width: 320px;
`
const ButtonContainer = styled.div`
  display: flex;
  width: 65px;
`
const RemoveButton = styled(Button)`
  background: red;
  color: white;
  max-height: 45px;
  min-height: 45px;
  height: 45px;
  max-width: 45px;
  min-width: 45px;
  border-radius: 10px;
  margin: auto;
`
const IconStyled = styled(Icon)`
  font-size: 24px;
`
const DragHandleStyled = styled(DragHandle)`
`

const Generic = ({
  children,
  hideButton,
  onClick,
  removeHandle,
  ...other
}) => {

  return (
    <CardStyled {...other}>
      { !removeHandle && <DragHandleStyled /> }
      {children}
      <ButtonContainer>
        { !hideButton && (
          <RemoveButton onClick={onClick}>
            <IconStyled>remove</IconStyled>
          </RemoveButton>
        )}
      </ButtonContainer>
    </CardStyled>
  )
}

Generic.propTypes = {
  onClick: PropTypes.func,
  removeHandle: PropTypes.bool,
};

Generic.defaultProps = {
  removeHandle: false,
};

export default sortableElement(Generic);
